// @flow
import React, { useState, useEffect } from 'react';

import Card from '../../../components/Cards/Card';

import styles from './ArticlesSave.module.scss';
import getDatabgPlo5 from '../../../controllers/BGsuitsPlo5.controller';

type IBG = {
  header: {
    textheader: string;
  };

  Content: {
    blockOne: {
      textboone: string;
      textbotwo: string;
      textbothree: string;
      imageUrl: string;
      textbofive: string;
      textbosix: string;
      textboseven: string;
      textboeight: string;
    };
    blockTwo: {
      blockHeaderbtwo: string;
      textbtwoone: string;
      textbtwotwo: string;
      textbtwothree: string;
      textbtfour: string;
      textbtfive: string;
      textbtsix: string;
      textbtseven: string;
      textbteight: string;
      textbtnine: string;
      textbtten: string;
      textbteleven: string;
    };
    blockThree: {
      localHeaderbthree: string;
      textbtone: string;
      textbttwo: string;
      textbtthree: string;
      textbtfour: string;
      textbtfive: string;
      textbtsix: string;
      textbtseven: string;
      textbteight: string;
      textbtnine: string;
      textbtten: string;
      textbteleven: string;
      textbttwelve: string;
      textbtthirteen: string;
      textbtfourteen: string;
      textbtfifteen: string;
      textbtsixteen: string;
      textbtseventeen: string;
      textbteighteen: string;
      textbtnineteen: string;
      textbttwenty: string;
      textbttwentyone: string;
      textbttwentytwo: string;
      textbttwentythree: string;
      textbttwentyfour: string;
      textbttwentyfive: string;
      textbttwentysix: string;
    };
  };
} | null

const BGsuitsPlo5 = () => {
  const [language, setLanguage] = useState<string>('');

  const [data, setData] = useState<IBG>(null);

  const getLanguage = () => {
    const locale = localStorage.getItem('i18nextLng');
    let languageKey;
    switch (locale) {
      case 'en':
        languageKey = 'Eng';
        break;
      case 'ru':
        languageKey = 'Rus';
        break;
      default:
        languageKey = 'Rus';
    }
    return languageKey;
  };

  useEffect(() => {
    setLanguage(getLanguage());
  }, []);

  const handleRes = async () => {
    const res = await getDatabgPlo5(getLanguage());

    setData(res);
  };

  useEffect(() => {
    handleRes();
  }, []);

  if (!data) return null;

  return (
    language
    && (
      <div id="root" className={styles.site}>
        <div className={`${styles.container} ${styles.minHI}`}>
          <div className={`${styles.header} ${styles.bg_header} ${styles.header_plo5}`}>
            <span className={styles.header_text}>{data.header?.textheader}</span>
          </div>
          <div className={`${styles.content} ${styles.content_plo5}`}>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content.blockOne.textboone}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content.blockOne?.textbotwo}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content.blockOne?.textbothree}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content.blockOne?.textbofour}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content.blockOne?.textbofive}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content.blockOne?.textbosix}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content.blockOne?.textboseven}
              </div>
            </div>
            <div className={styles.bg_block}>
              <div className={styles.text}>
                {data.Content.blockOne?.textboeight}
              </div>
            </div>
            <div className={styles.block}>
              <span className={`${styles.local_header} ${styles.good_suit}`}>
                {data.Content.blockTwo.blockHeaderbtwo}
              </span>
            </div>
            <div className={styles.bg_block}>
              <span className={`${styles.text} ${styles.inlineBox}`}>
                {data.Content.blockTwo.textbtwoone}
                <div className={styles.small_hand_plo5}>
                  <Card mast="no" bg="blank" size="small" value="A" />
                  <Card mast="no" bg="blank" size="small" value="K" />
                  <Card mast="no" bg="blank" size="small" value="J" />
                  <Card mast="no" bg="blank" size="small" value="T" />
                  <Card mast="no" bg="blank" size="small" value="2" />
                </div>
                {data.Content.blockTwo.textbtwotwo}
                <div className={styles.small_hand_plo5}>
                  <Card mast="no" bg="blank" size="small" value="T" />
                  <Card mast="no" bg="blank" size="small" value="T" />
                  <Card mast="no" bg="blank" size="small" value="5" />
                  <Card mast="no" bg="blank" size="small" value="4" />
                  <Card mast="no" bg="blank" size="small" value="3" />
                </div>
                ,
                <div className={styles.small_hand_plo5}>
                  <Card mast="no" bg="blank" size="small" value="T" />
                  <Card mast="no" bg="blank" size="small" value="T" />
                  <Card mast="no" bg="blank" size="small" value="A" />
                  <Card mast="no" bg="blank" size="small" value="4" />
                  <Card mast="no" bg="blank" size="small" value="3" />
                </div>
                {data.Content.blockTwo.textbtwothree}
                <div className={styles.small_hand_plo5}>
                  <Card mast="no" bg="blank" size="small" value="T" />
                  <Card mast="no" bg="blank" size="small" value="T" />
                  <Card mast="no" bg="blank" size="small" value="9" />
                  <Card mast="no" bg="blank" size="small" value="9" />
                  <Card mast="no" bg="blank" size="small" value="5" />
                </div>
                ,
                <div className={styles.small_hand_plo5}>
                  <Card mast="no" bg="blank" size="small" value="T" />
                  <Card mast="no" bg="blank" size="small" value="T" />
                  <Card mast="no" bg="blank" size="small" value="9" />
                  <Card mast="no" bg="blank" size="small" value="9" />
                  <Card mast="no" bg="blank" size="small" value="K" />
                </div>
              </span>
            </div>
            <div className={styles.bg_block}>
              <span className={styles.text}>
                {data.Content.blockTwo.textbtwfour}
              </span>
            </div>
            <div className={styles.bg_block}>
              <span className={styles.text}>
                {data.Content.blockTwo.textbtwfive}
              </span>
            </div>
            <div className={styles.bg_block}>
              <span className={styles.text}>
                {data.Content.blockTwo.textbtwsix}
              </span>
            </div>
            <div className={styles.bg_block}>
              <span className={styles.text}>
                {data.Content.blockTwo.textbtwseven}
              </span>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="K" />
                <Card mast="bubi" bg="grey" size="big" value="J" />
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="picki" bg="black" size="big" value="2" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtweight}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="kresti" bg="green" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="K" />
                <Card mast="chervi" bg="red" size="big" value="J" />
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="2" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtwnine}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="K" />
                <Card mast="bubi" bg="grey" size="big" value="J" />
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="2" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtwten}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="bubi" bg="grey" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="K" />
                <Card mast="chervi" bg="red" size="big" value="J" />
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="2" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtweleven}
              </div>
            </div>
            <div className={`${styles.bg_block} ${styles.mt24}`}>
              <span className={`${styles.text} ${styles.inlineBox}`}>
                {data.Content.blockTwo.textbtwtwelve}
                TT543
                {data.Content.blockTwo.textbtwtwelveSub1}
                TTA43
                {data.Content.blockTwo.textbtwtwelveSub2}
              </span>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="chervi" bg="red" size="big" value="5" />
                <Card mast="bubi" bg="grey" size="big" value="4" />
                <Card mast="picki" bg="black" size="big" value="3" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtwthirteen}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="T" />
                <Card mast="picki" bg="black" size="big" value="T" />
                <Card mast="chervi" bg="red" size="big" value="A" />
                <Card mast="bubi" bg="grey" size="big" value="4" />
                <Card mast="bubi" bg="grey" size="big" value="3" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtwfourteen}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="T" />
                <Card mast="picki" bg="black" size="big" value="T" />
                <Card mast="chervi" bg="red" size="big" value="5" />
                <Card mast="bubi" bg="grey" size="big" value="4" />
                <Card mast="bubi" bg="grey" size="big" value="3" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtwfourteenSub1}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="picki" bg="black" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="4" />
                <Card mast="bubi" bg="grey" size="big" value="3" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtwfourteenSub2}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="chervi" bg="red" size="big" value="5" />
                <Card mast="bubi" bg="grey" size="big" value="4" />
                <Card mast="bubi" bg="grey" size="big" value="3" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtwfourteenSub3}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="chervi" bg="red" size="big" value="A" />
                <Card mast="bubi" bg="grey" size="big" value="4" />
                <Card mast="bubi" bg="grey" size="big" value="3" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtwfourteenSub4}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="4" />
                <Card mast="bubi" bg="grey" size="big" value="3" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtwfourteenSub5}
              </div>
            </div>
            <div className={`${styles.bg_block} ${styles.mt24}`}>
              <span className={styles.text}>
                {data.Content.blockTwo.textbtwfifteen}
              </span>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="chervi" bg="red" size="big" value="9" />
                <Card mast="bubi" bg="grey" size="big" value="9" />
                <Card mast="picki" bg="black" size="big" value="5" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtwsixteen}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="chervi" bg="red" size="big" value="T" />
                <Card mast="picki" bg="black" size="big" value="9" />
                <Card mast="chervi" bg="red" size="big" value="9" />
                <Card mast="bubi" bg="grey" size="big" value="K" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtwseventeen}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="picki" bg="black" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="chervi" bg="red" size="big" value="9" />
                <Card mast="bubi" bg="grey" size="big" value="9" />
                <Card mast="chervi" bg="red" size="big" value="5" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtwseventeenSub1}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="chervi" bg="red" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="9" />
                <Card mast="chervi" bg="red" size="big" value="9" />
                <Card mast="picki" bg="black" size="big" value="K" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtwseventeenSub2}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="chervi" bg="red" size="big" value="9" />
                <Card mast="bubi" bg="grey" size="big" value="9" />
                <Card mast="chervi" bg="red" size="big" value="5" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtwseventeenSub3}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="chervi" bg="red" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="9" />
                <Card mast="chervi" bg="red" size="big" value="9" />
                <Card mast="bubi" bg="grey" size="big" value="K" />
              </div>
              <div className={styles.text}>
                {data.Content.blockTwo.textbtwseventeenSub4}
              </div>
            </div>
            <div className={styles.block}>
              <span className={`${styles.local_header} ${styles.single_suit}`}>
                {data.Content.blockThree.blockHeaderThree}
              </span>
            </div>
            <div className={styles.bg_block}>
              <span className={`${styles.text} ${styles.inlineBox}`}>
                {data.Content.blockThree.textbttone}
                <div className={styles.small_hand_plo5}>
                  <Card mast="no" bg="blank" size="small" value="A" />
                  <Card mast="no" bg="blank" size="small" value="K" />
                  <Card mast="no" bg="blank" size="small" value="J" />
                  <Card mast="no" bg="blank" size="small" value="T" />
                  <Card mast="no" bg="blank" size="small" value="2" />
                </div>
                {data.Content.blockThree.textbtttwo}
                <div className={styles.small_hand_plo5}>
                  <Card mast="no" bg="blank" size="small" value="A" />
                  <Card mast="no" bg="blank" size="small" value="A" />
                  <Card mast="no" bg="blank" size="small" value="K" />
                  <Card mast="no" bg="blank" size="small" value="J" />
                  <Card mast="no" bg="blank" size="small" value="2" />
                </div>
                {data.Content.blockThree.textbttthree}
                <div className={styles.small_hand_plo5}>
                  <Card mast="no" bg="blank" size="small" value="A" />
                  <Card mast="no" bg="blank" size="small" value="A" />
                  <Card mast="no" bg="blank" size="small" value="K" />
                  <Card mast="no" bg="blank" size="small" value="K" />
                  <Card mast="no" bg="blank" size="small" value="2" />
                </div>
              </span>
            </div>
            <div className={styles.bg_block}>
              <span className={styles.text}>
                {data.Content.blockThree.textbttfour}
              </span>
            </div>
            <div className={styles.bg_block}>
              <span className={styles.text}>
                {data.Content.blockThree.textbttffive}
              </span>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="A" />
                <Card mast="picki" bg="black" size="big" value="K" />
                <Card mast="chervi" bg="red" size="big" value="J" />
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="kresti" bg="green" size="big" value="2" />
              </div>
              <div className={styles.text}>
                {data.Content.blockThree.textbttsix}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="K" />
                <Card mast="chervi" bg="red" size="big" value="J" />
                <Card mast="picki" bg="black" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="2" />
              </div>
              <div className={styles.text}>
                {data.Content.blockThree.textbttseven}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="picki" bg="black" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="K" />
                <Card mast="chervi" bg="red" size="big" value="J" />
                <Card mast="bubi" bg="grey" size="big" value="T" />
                <Card mast="kresti" bg="green" size="big" value="2" />
              </div>
              <div className={styles.text}>
                {data.Content.blockThree.textbtteight}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="picki" bg="black" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="K" />
                <Card mast="chervi" bg="red" size="big" value="J" />
                <Card mast="chervi" bg="red" size="big" value="T" />
                <Card mast="bubi" bg="grey" size="big" value="2" />
              </div>
              <div className={styles.text}>
                {data.Content.blockThree.textbttnine}
              </div>
            </div>
            <div className={`${styles.bg_block} ${styles.mt24}`}>
              <span className={styles.text}>
                {data.Content.blockThree.textbttten}
              </span>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="A" />
                <Card mast="picki" bg="black" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="K" />
                <Card mast="bubi" bg="grey" size="big" value="J" />
                <Card mast="kresti" bg="green" size="big" value="2" />
              </div>
              <div className={styles.text}>
                {data.Content.blockThree.textbtteleven}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="A" />
                <Card mast="picki" bg="black" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="K" />
                <Card mast="chervi" bg="red" size="big" value="J" />
                <Card mast="kresti" bg="green" size="big" value="2" />
              </div>
              <div className={styles.text}>
                {data.Content.blockThree.textbtttwelve}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="picki" bg="black" size="big" value="A" />
                <Card mast="bubi" bg="grey" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="K" />
                <Card mast="chervi" bg="red" size="big" value="J" />
                <Card mast="kresti" bg="green" size="big" value="2" />
              </div>
              <div className={styles.text}>
                {data.Content.blockThree.textbtthirteen}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="bubi" bg="grey" size="big" value="A" />
                <Card mast="picki" bg="black" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="K" />
                <Card mast="chervi" bg="red" size="big" value="J" />
                <Card mast="chervi" bg="red" size="big" value="2" />
              </div>
              <div className={styles.text}>
                {data.Content.blockThree.textbttfourteen}
              </div>
            </div>
            <div className={`${styles.bg_block} ${styles.mt24}`}>
              <span className={styles.text}>
                {data.Content.blockThree.textbttfifteen}
              </span>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="A" />
                <Card mast="picki" bg="black" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="K" />
                <Card mast="bubi" bg="grey" size="big" value="K" />
                <Card mast="kresti" bg="green" size="big" value="2" />
              </div>
              <div className={styles.text}>
                {data.Content.blockThree.textbttsixteen}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="chervi" bg="red" size="big" value="A" />
                <Card mast="picki" bg="black" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="K" />
                <Card mast="bubi" bg="grey" size="big" value="K" />
                <Card mast="chervi" bg="red" size="big" value="2" />
              </div>
              <div className={styles.text}>
                {data.Content.blockThree.textbttseventeen}
              </div>
            </div>
            <div className={styles.card_and_text_box_plo5}>
              <div className={styles.hand_plo5}>
                <Card mast="picki" bg="black" size="big" value="A" />
                <Card mast="bubi" bg="grey" size="big" value="A" />
                <Card mast="chervi" bg="red" size="big" value="K" />
                <Card mast="kresti" bg="green" size="big" value="K" />
                <Card mast="chervi" bg="red" size="big" value="2" />
              </div>
              <div className={styles.text}>
                {data.Content.blockThree.textbtteighteen}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default BGsuitsPlo5;
